import { IDatatype } from "@/api/datatypes";
import { Button } from "@/components/shared/buttons/Button";
import {
    Chip,
    Dialog,
    DialogContent,
    DialogTitle,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { DialogProps } from "@toolpad/core/useDialogs";

interface IDatatypeSchemaDialogProps {
    datatype: IDatatype;
}

export const DatatypeSchemaDialog = ({
    open,
    onClose,
    payload,
}: DialogProps<IDatatypeSchemaDialogProps>) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const { datatype } = payload;

    return (
        <Dialog
            open={open}
            onClose={() => onClose()}
            maxWidth="md"
            fullWidth
            fullScreen={isMobile}
        >
            <DialogTitle>
                <Stack spacing={1}>
                    <Typography variant="h6" fontWeight={600}>
                        {datatype.name} Schema
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        {datatype.description}
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Stack spacing={3}>
                    {datatype.datatype_schema &&
                    datatype.datatype_schema.length > 0 ? (
                        <TableContainer>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Property</TableCell>
                                        <TableCell>Type</TableCell>
                                        <TableCell>Description</TableCell>
                                        <TableCell>Required</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {datatype.datatype_schema.map(
                                        (property, index) => (
                                            <TableRow key={index}>
                                                <TableCell>
                                                    <Typography
                                                        variant="body2"
                                                        fontWeight={500}
                                                    >
                                                        {property.name}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Chip
                                                        label={property.type}
                                                        size="small"
                                                        variant="outlined"
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    {property.description}
                                                </TableCell>
                                                <TableCell>
                                                    {property.required ? (
                                                        <Chip
                                                            label="Yes"
                                                            size="small"
                                                            color="primary"
                                                        />
                                                    ) : (
                                                        <Chip
                                                            label="No"
                                                            size="small"
                                                            variant="outlined"
                                                        />
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        )
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : (
                        <Typography variant="body2" color="textSecondary">
                            This is a base datatype with no complex schema.
                        </Typography>
                    )}

                    <Stack direction="row" justifyContent="flex-end">
                        <Button
                            variant="contained"
                            color="dark"
                            onClick={() => onClose()}
                            sx={{ borderRadius: 2, py: 1 }}
                        >
                            Close
                        </Button>
                    </Stack>
                </Stack>
            </DialogContent>
        </Dialog>
    );
};
